import { trim } from "utils/string.util";

function triggerEvent(el, eventName, state) {
	let event;
	if (document.createEvent) {
		event = document.createEvent('HTMLEvents');
		event.initEvent(eventName, true, true);
	} else if (document.createEventObject) {// IE < 9
		event = document.createEventObject();
		event.eventType = eventName;
	}
	event.state = state;
	event.eventName = eventName;
	if (el.dispatchEvent) {
		el.dispatchEvent(event);
	} else if (el.fireEvent && htmlEvents['on' + eventName]) {// IE < 9
		el.fireEvent('on' + event.eventType, event);// can trigger only real event (e.g. 'click')
	} else if (el[eventName]) {
		el[eventName]();
	} else if (el['on' + eventName]) {
		el['on' + eventName]();
	}
}

function addEventListener(el, type, handler) {
	if (el.addEventListener) {
		el.addEventListener(type, handler);
	} else if (el.attachEvent && htmlEvents['on' + type]) {// IE < 9
		el.attachEvent('on' + type, handler);
	} else {
		el['on' + type] = handler;
	}
}

function removeEventListener(el, type, handler) {
	if (el.removeEventListener) {
		el.removeEventListener(type, handler);
	} else if (el.detachEvent && htmlEvents['on' + type]) {// IE < 9
		el.detachEvent('on' + type, handler);
	} else {
		el['on' + type] = null;
	}
}

export default class Location {
	static get isSupported() {
		return typeof window != 'undefined' && window.history && 'pushState' in window.history;
	}

	static get pathname() {
		// Return the pathname with all leading and trailing slashes, for normalization
		return (window.location.pathname || "").replace(/(^\/+)|(\/+$)/gi, "");
	}

	static get search() {
		if (window.location.search) {
			let search = window.location.search;

			if (search.charAt(0) === "?") {
				search = search.slice(1);
			}

			return search;
		}

		// Get the full url
		let href = window.location.href;

		// Remove the hash
		const hashMarkIndex = href.indexOf("#");
		if (hashMarkIndex > -1) {
			href = href.slice(0, hashMarkIndex)
		}


		const questionMarkIndex = href.indexOf("?");
		if (questionMarkIndex < 0) {
			return "";
		}

		return href.slice(questionMarkIndex + 1);
	}

	static get baseUrl() {
		return window.location.href.split("?")[0];
	}

	static get queryParams() {
		const queryParams = {};
		const search = trim(this.search);
		if (search.length > 0) {
			search.split("&").forEach((pair) => {
				let [key, value] = pair.split("=");
				queryParams[key] = unescape(value);
			});
		}

		return queryParams;
	}

    static hasQueryParam(key) {
        return this.queryParams.hasOwnProperty(key);
    }

	static getQueryParam(key) {
		return this.queryParams[key];
	}

	static getIntQueryParam(key) {
		let param = this.getQueryParam(key);

		if (!param) {
			return undefined;
		}

		param = parseInt(param);

		if (isNaN(param)) {
			return 0;
		}

		return param;
	}

	static updateQueryParams(params = {}, state = {}, title = undefined) {
		const queryParams = Object.assign({}, this.queryParams, params);
		const queryPieces = [];

		for (let key in queryParams) {
			if(queryParams[key]) { // if property is empty don't add to the query string
				queryPieces.push(`${key}=${queryParams[key]}`)
			}
		}

		const href = [this.baseUrl];
		if (queryPieces.length > 0) {
			href.push(queryPieces.join("&"))
		}

		this.pushState(state, title, href.join("?"));
	}

	static pushState(state, title, href) {
		let ps = window.history.pushState.call(history, state, title, href);
		triggerEvent(window, 'pushstate', state);
		triggerEvent(window, 'changestate', state);
		return ps;
	}

	static replaceState(state, title, href) {
		let rs = window.history.replaceState.call(history, state, title, href);
		triggerEvent(window, 'replacestate', state);
		triggerEvent(window, 'changestate', state);
		return rs;
	}

	static addEventListener(eventName, listener) {
		return addEventListener(window, eventName, listener)
	}

	static removeEventListener(eventName, listener) {
		return removeEventListener(window, eventName, listener)
	}
}

Location.addEventListener('popstate', function (e) {
	triggerEvent(window, 'changestate', e.state);
});
